import { render, staticRenderFns } from "./RemarkInputView.vue?vue&type=template&id=160fa89c&scoped=true&"
import script from "./RemarkInputView.vue?vue&type=script&lang=js&"
export * from "./RemarkInputView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "160fa89c",
  null
  
)

export default component.exports